import { useState } from 'react';
import { DonViCoSo, KhachHang, KhoHang, NhanVien, VatTu } from '@/types/schemas';

export interface SearchFieldState {
  khachHang: KhachHang | null;
  nhanVien: NhanVien | null;
  vatTu: VatTu | null;
  kho: KhoHang | null;
  donVi: DonViCoSo | null;
}

export interface SearchFieldActions {
  setKhachHang: (khachHang: KhachHang | null) => void;
  setNhanVien: (nhanVien: NhanVien | null) => void;
  setVattu: (vatTu: VatTu | null) => void;
  setKho: (kho: KhoHang | null) => void;
  setDonVi: (donVi: DonViCoSo | null) => void;

  // Utility functions
  resetState: () => void;
  updateState: (updates: Partial<SearchFieldState>) => void;
}

export interface UseSearchFieldStateReturn {
  state: SearchFieldState;
  actions: SearchFieldActions;
}

const initialState: SearchFieldState = {
  khachHang: null,
  nhanVien: null,
  vatTu: null,
  kho: null,
  donVi: null
};

function transformInitialData(initialData?: BanHangRecord): Partial<SearchFieldState> {
  if (!initialData) return {};

  return {
    khachHang: initialData.ma_kh_data || initialData.khachHang || null,
    nhanVien: initialData.ma_nvbh_data || initialData.nhanVien || null,
    vatTu: initialData.ma_vt_data || initialData.vatTu || null,
    kho: initialData.ma_kho_data || initialData.kho || null,
    donVi: initialData.ma_unit_data || initialData.donVi || null
  };
}

export function useSearchFieldState(initialData?: BanHangRecord): UseSearchFieldStateReturn {
  const [state, setState] = useState<SearchFieldState>({
    ...initialState,
    ...transformInitialData(initialData)
  });

  const actions: SearchFieldActions = {
    setKhachHang: (khachHang: KhachHang | null) => {
      setState(prev => ({
        ...prev,
        khachHang
      }));
    },

    setNhanVien: (nhanVien: NhanVien | null) => {
      setState(prev => ({
        ...prev,
        nhanVien
      }));
    },

    setVattu: (vatTu: VatTu | null) => {
      setState(prev => ({
        ...prev,
        vatTu
      }));
    },

    setKho: (kho: KhoHang | null) => {
      setState(prev => ({
        ...prev,
        kho
      }));
    },

    setDonVi: (donVi: DonViCoSo | null) => {
      setState(prev => ({
        ...prev,
        donVi
      }));
    },

    resetState: () => {
      setState(initialState);
    },

    updateState: (updates: Partial<SearchFieldState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
